import React, { useEffect, useState } from 'react';
import { Field, Formik } from 'formik';
import { connect } from 'react-redux';

// import {
//   createSupplierProductAction,
//   updateSupplierProductAction,
//   getSupplierProductAction,
// } from '../../../../modules/supplierProducts/Actions';

import {
  createMySupplierProductAction,
  updateMySupplierProductAction,
  getMySingleProductSupplierAction
} from '../../../../modules/myProductList/Supplier/Actions';
import ProductBIOi18n from '../../../../components/form/i18nForm/FormBIOi18n';
// import {
//   supplierProductsIsLoadingSelector,
//   supplierProductByIdSelector,
// } from '../../../../modules/supplierProducts/Selectors';

import {
  supplierProductByIdSelector,
  supplierProductsIsLoadingSelector
} from '../../../../modules/myProductList/Supplier/Selectors';

import {
  supplierTagsAsLabelAndValueSelector,
  supplierTagsIsLoadingSelector
} from '../../../../modules/supplierTags/Selectors';

import { getSupplierTagsAction } from '../../../../modules/supplierTags/Actions';

import { getSupplierCategoriesAction } from '../../../../modules/supplierCategories/Actions';
import {
  supplierCategoriesListSelector,
  supplierCategoriesIsLoadingSelector
} from '../../../../modules/supplierCategories/Selectors';

import {
  errorNotificationFromError,
  newErrorNotificationAction
} from '../../../../modules/notifications/Actions';

import {
  FormGroup,
  InputField,
  CheckBox,
  TextArea,
  MultiInputField,
  SearchableSelect,
  MultiUpload,
  FormSectionTitle,
  DatePicker,
  Separator,
  ColorPicker
} from '../../../../components/form';

import FormBIOi18n from '../../../../components/form/i18nForm/FormBIOi18n';

import Iframe from 'react-iframe';

import schema from './schema';
import { FormattedMessage, injectIntl } from 'react-intl';
import { supplierDataSelector } from '../../../../modules/auth/Selectors';
import { makeid } from '../../artisanProducts/ArtisanProductsForm';
import getLangData from '../../../../utils/getLangData';

/*
{
  "descriptioni18n": { "chinese_zh_man": "在建于1285年的苏丹曼苏尔·卡劳翁陵墓中，苏丹在开罗统治期间建造的第一个圆顶是精美的马赛克大理石镶板，充满动感和现代感。 Qalawun袖口的设计始终遵循这种细长设计" },
  "productImages": [ { "imagePath": "https://media.azza-cdn.net/catalog/product/cache/c687aa7517cf01e65c009f6943c2b1e9/c/b/cbsg.20-003.jpg", "shortDesc": "short desc", "longDesc": "long desc", "featured": "true" }, { "imagePath": "https://media.azza-cdn.net/catalog/product/cache/c687aa7517cf01e65c009f6943c2b1e9/c/b/cbsg.20-003_1.jpg", "shortDesc": "short desc", "longDesc": "test long desc", "featured": "true" } ],
  "video": "",
}
*/
const profileLang = getLangData().profile_types;
const fieldsLang = getLangData().fields;
const buttonsLang = getLangData().buttons;
const SupplierProductsForm = props => {
  const {
    getSuppliers,
    productId,
    isLoading,
    createSupplierProduct,
    updateSupplierProduct,
    getSupplierProduct,
    supplierProduct,
    tagsIsLoading,
    tags,
    getSupplierTags,

    getCategories,
    categories,
    categoriesIsLoading,
    supplierData,
    errorNotification
  } = props;

  // for testing only

  const supplierId = supplierData?._id;

  function getIdfromYTLink(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);

    return match && match[2].length === 11 ? match[2] : null;
  }
  const replaceYTLinkFromWatchToEmbed = url => {
    const id = getIdfromYTLink(url);
    // return url.replace('watch?v=', 'embed/');
    return `https://www.youtube.com/embed/${id}`;
  };
  const [size, setSize] = useState(10);

  useEffect(() => {
    if (productId) {
      getSupplierProduct(productId);
      getCategories({ size: 50 });
      // getSuppliers(size);
      getSupplierTags();
    } else {
      getCategories({ size: 50 });
      // getSuppliers(size);
      getSupplierTags();
    }
  }, [getSupplierProduct, productId]);

  return (
    <Formik
      validationSchema={schema()}
      enableReinitialize
      initialValues={
        supplierProduct
          ? {
            ...supplierProduct
          }
          : schema().cast()
      }
      onSubmit={async values => {
        values.productID = `SP${makeid(15)}`;

        // Supplier Category Id
        let supplierCID;
        if (supplierProduct) {
          if (Array.isArray(values.supplierCategoryData)) {
            supplierCID = values.supplierCategoryData[0]._id;
          } else {
            supplierCID = values.supplierCategoryData._id;
          }
        } else {
          supplierCID = values.supplierCID._id;
        }

        // Tags

        const mappedTags = supplierProduct ? values.tagsData : values.tags;
        const tags = mappedTags.map(t => (typeof t === 'object' ? t._id : t));

        function ytVidId(url) {
          var p = /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?(?=.*v=((\w|-){11}))(?:\S+)?$/;
          return url.match(p) ? RegExp.$1 : false;
        }
        if (values.video) {
          const validYT = ytVidId(values.video);
          if (validYT) {
            if (productId) {
              updateSupplierProduct(productId, {
                ...values,
                supplierCID,
                supplierID: supplierId,
                tags
              });
            } else {
              createSupplierProduct({
                ...values,
                supplierCID,
                supplierID: supplierId,
                tags
              });
            }
          } else {
            errorNotificationFromError('Youtube Link not valid');
          }
        } else {
          if (productId) {
            await updateSupplierProduct('', {
              supplierProductID: productId,
              ...values,
              supplierCID,
              supplierID: supplierId,
              tags
            });
          } else {
            await createSupplierProduct({
              ...values,
              supplierCID,
              supplierID: supplierId,
              tags
            });
          }
        }
        // console.log(values.offerExpires)
      }}
    >
      {({ values, handleSubmit, setFieldValue, errors }) => (
        <FormGroup
          handleSubmit={handleSubmit}
          isLoading={isLoading}
          errors={errors}
          heading={
            supplierProduct
              ? `${buttonsLang.update} [${supplierProduct.name}]`
              : buttonsLang.create
          }
        >
          <FormSectionTitle>{getLangData().tables.basic_info}</FormSectionTitle>

          {/* <ProductBIOi18n name="namei18n" description="Product Name" /> */}
          <InputField name='name' label={fieldsLang.name} />
          <ProductBIOi18n name='namei18n' description={fieldsLang.name} />
          {/* <InputField name="productID" label="Product ID" /> */}
          <SearchableSelect
            name={supplierProduct ? 'supplierCategoryData' : 'supplierCID'}
            label={fieldsLang.category}
            getItems={getCategories}
            options={categories}
            isLoading={categoriesIsLoading}
          />

          <SearchableSelect
            isMulti={true}
            name={supplierProduct ? 'tagsData' : 'tags'}
            label={getLangData().menu.side.tags}
            getItems={getSupplierTags}
            isLoading={tagsIsLoading}
            options={tags}
          />

          <TextArea name='description' label={fieldsLang.descrition} />
          <ProductBIOi18n name='descriptioni18n' description={fieldsLang.descrition} />

          {/* <MultiInputField name="metaKeywords" label="Keywords" /> */}
          <MultiInputField name='material' label={fieldsLang.material} />
          {/* <MultiInputField name="colors" label="Colors" /> */}
          <ColorPicker
            // setValue={setFieldValue}
            // errorNotification={errorNotification}
            name='colors'
            label={fieldsLang.colors}
            setField={color => {
              // const colorCode = color.hex
              console.log(values);
              if (values.colors.length <= 5) {
                setFieldValue('colors', [...values.colors, color.hex]);
              } else {
                errorNotification('Too Many Colors! 5 Max');
              }
            }}
            value={values.colors}
            color={values.colors[values.colors.length - 1]}
            setFieldValue={setFieldValue}
          />
          <InputField name='size' label={fieldsLang.size} />
          <InputField name='usage' label={fieldsLang.usage} />
          <InputField
            name='priceFrom'
            label={fieldsLang.price_from}
          // placeholder='Price Range e.g. $200 USD'
          />
          <InputField
            name='priceTo'
            label={fieldsLang.price_to}
          // placeholder='Price Range e.g. $200 USD'
          />

          <MultiUpload
            data={{ supplierID: supplierId }}
            S3Bucket='warshatna-suppliers-products'
            API='supplier/supplier-product-image-signedurl/'
            data=''
            name='productImages'
            label={fieldsLang.image}
          />

          <InputField name='video' label={fieldsLang.youtube_link} />

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignitems: 'center',
              margin: '30px 0'
            }}
          >
            {values.video && (
              <Iframe
                url={replaceYTLinkFromWatchToEmbed(values.video)}
                width='70%'
                height='300px'
              />
            )}
          </div>

          {
            //
            //          <FieldArray name='productImages'>
            //            {({move, swap, push, insert, unshift, pop, form , name}) => {
            //              const {values} = form;
            // render file input
            //         return (<h1>hi</h1>)
            //              {values[name] && values[name].length > 1 && values[name].map((value , index) => {
            //              return (<pre>{JSON.stringify(value , null ,2)}</pre>)
            //               return (
            //                  <Field key={`${name}[${index}]`} name={`${name}[${index}]`}>
            //                    {({form , field}) => {
            //                      return ( <pre>
            //                       {JSON.stringify(field.value , null ,2 )}
            //                      </pre>)
            //                    }}
            //                  </Field>
            //                )
            //              })}
            //            }}
            //         </FieldArray>
          }

          <CheckBox name='discounted' label={fieldsLang.discounted} />
          {values.discounted && <InputField name='discount' label={fieldsLang.discount} />}
          {/*           {values.discounted && <DatePicker name='offerExpires' label='Offer Expires' />}
           */}
          <CheckBox name='hasBuyNowLink' label={fieldsLang.has_buy_now_link} />
          {values.hasBuyNowLink && (
            <InputField name='buyNowLink' label='Buy Now Link' />
          )}

          <Separator />
          <FormSectionTitle>{fieldsLang.product_status}</FormSectionTitle>
          <CheckBox name='packed' label={fieldsLang.packed} />
          <CheckBox name='shippableLocal' label={fieldsLang.shippable_local} />
          <CheckBox
            name='shippableInter'
            label={fieldsLang.shippable_inter}
          />{' '}
        </FormGroup>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const productId = props.match.params.id;
  return {
    productId,
    isLoading: supplierProductsIsLoadingSelector(state),
    supplierProduct: supplierProductByIdSelector(state, productId),
    // suppliers: suppliersAsLabelAndValueSelector(state),
    // suppliersIsLoading: suppliersIsLoadingSelector(state),
    tags: supplierTagsAsLabelAndValueSelector(state),
    // tagsIsLoading: supplierTagsIsLoadingSelector(state),

    categories: supplierCategoriesListSelector(state),
    supplierData: supplierDataSelector(state)
    // categoriesIsLoading: supplierCategoriesIsLoadingSelector(state),
  };
};

export default injectIntl(
  connect(mapStateToProps, {
    getSupplierProduct: getMySingleProductSupplierAction,
    createSupplierProduct: createMySupplierProductAction,
    updateSupplierProduct: updateMySupplierProductAction,
    getSupplierTags: getSupplierTagsAction,
    errorNotification: newErrorNotificationAction,
    getCategories: getSupplierCategoriesAction
  })(SupplierProductsForm)
);

//  createMySupplierProductAction, updateMySupplierProductAction, getMySingleProductArtisanAction
